<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    stroke="currentColor"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.25 7.17855H13.5C13.5 4.6637 11.4853 2.625 9 2.625C6.51472 2.625 4.5 4.6637 4.5 7.17855H2.75C2.47386 7.17855 2.25 7.40507 2.25 7.6845V11.4285C2.25 11.708 2.47386 11.9345 2.75 11.9345H5.5V7.38093C5.53015 5.45398 7.09564 3.91513 9 3.94047C10.9044 3.91513 12.4698 5.45398 12.5 7.38093V10.9226C12.4698 12.8495 10.9044 14.3884 9 14.363V15.375C11.0692 15.382 12.8765 13.9603 13.38 11.9294H15.25C15.5261 11.9294 15.75 11.7029 15.75 11.4235V7.6845C15.75 7.40507 15.5261 7.17855 15.25 7.17855ZM3.25 10.9226V8.19045H4.5V10.9226H3.25ZM14.75 10.9226H13.5V8.19045H14.75V10.9226Z"
      stroke-width="0.1"
    />
    <path
      d="M10.865 9.82973C10.3559 10.4136 9.63378 10.7625 8.865 10.7961C8.10562 10.738 7.39383 10.3994 6.865 9.84491L6.125 10.5279C6.8309 11.2786 7.78855 11.7351 8.81 11.808H8.885C9.91009 11.7743 10.8768 11.3172 11.56 10.5431L10.865 9.82973Z"
      stroke-width="0.1"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
@Component
export default class CustomerSupportIcon extends Vue {}
</script>
